import Button, { ButtonProps } from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import DialogActions, { DialogActionsProps } from '@mui/material/DialogActions'
import React from 'react'

import { RootContext } from './DialogGuideRoot'
import { useSetInternalProps } from './utils'

interface ActionsProps extends DialogActionsProps {
    children?: React.ReactNode
}

function ActionsRoot({ children, ...props }: ActionsProps) {
    return <DialogActions {...props}>{children}</DialogActions>
}

interface PrimaryButtonProps extends ButtonProps {
    closeOnSubmit?: boolean
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
    children,
    closeOnSubmit,
    ...props
}) => {
    useSetInternalProps({ closeOnSubmit })

    return (
        <RootContext.Consumer>
            {({ loading, onSubmit, methods, delete: _delete, onDelete }) =>
                onSubmit || (_delete && onDelete) ? (
                    <Button
                        data-testid="dialog-primary-button"
                        onClick={() => {
                            if (_delete && onDelete) {
                                methods.handleSubmit(onDelete)()
                            } else if (onSubmit) {
                                methods.handleSubmit(onSubmit)()
                            }
                        }}
                        variant="contained"
                        disabled={loading || props.disabled}
                        color={_delete ? 'error' : 'primary'}
                        startIcon={
                            loading ? (
                                <CircularProgress size={20} />
                            ) : (
                                props.startIcon
                            )
                        }
                        {...props}
                    >
                        {children || (_delete ? 'Excluir' : 'Salvar')}
                    </Button>
                ) : null
            }
        </RootContext.Consumer>
    )
}

const SecondaryButton: React.FC<ButtonProps> = ({ children, ...props }) => {
    return (
        <RootContext.Consumer>
            {({ loading, onClose }) => (
                <Button
                    datatype="dialog-secondary-button"
                    onClick={onClose}
                    disabled={loading}
                    {...props}
                >
                    {children || 'Cancelar'}
                </Button>
            )}
        </RootContext.Consumer>
    )
}

ActionsRoot.PrimaryButton = PrimaryButton
ActionsRoot.SecondaryButton = SecondaryButton

export { ActionsRoot as Actions }
